import { IconLock, IconUsers } from '@tabler/icons-react'
import type { ProjectRole, Visibility } from '@/api/types'
import { tr } from '@/i18n/tr'
import { Badge } from '@/ui'
import { ink, tint } from '@/ui/palette'

/**
 * Rol ve görünürlük rozetleri. Renk anlam taşır: sahiplik mürekkep, düzenleme
 * yetkisi deniz mavisi, yalnızca görüntüleme nötr, test eden menekşe. Aynı rozet
 * her ekranda aynı renkte görünür.
 */
const ROLE_LABEL: Record<ProjectRole, string> = {
  OWNER: tr.member.owner,
  EDITOR: tr.member.editor,
  VIEWER: tr.member.viewer,
  TESTER: tr.member.tester,
}

/**
 * @param role  rolün eski adlara izdüşümü: rozetin tonunu belirler
 * @param name  atanmış rolün adı ("Proje Yöneticisi"); yoksa izdüşümün adı yazılır
 * @param color rolün kendi rengi (#RRGGBB) varsa ton yerine o kullanılır
 */
export function RoleBadge({ role, name, color, size = 'sm' }: {
  role: ProjectRole
  name?: string | null
  color?: string | null
  size?: string
}) {
  const sm = size === 'xs'
  const label = name || ROLE_LABEL[role]
  if (color) return <Badge size={sm ? 'sm' : 'md'} bg={`${color}24`} fg={color}>{label}</Badge>
  if (role === 'OWNER') return <Badge tone="ink" size={sm ? 'sm' : 'md'}>{label}</Badge>
  if (role === 'VIEWER') return <Badge tone="neutral" size={sm ? 'sm' : 'md'}>{label}</Badge>
  const c = role === 'EDITOR' ? 'teal' : 'violet'
  return <Badge size={sm ? 'sm' : 'md'} bg={tint(c)} fg={ink(c)}>{label}</Badge>
}

export function VisibilityBadge({ visibility }: { visibility: Visibility }) {
  return visibility === 'PRIVATE'
    ? <Badge tone="neutral" icon={<IconLock size={12} stroke={2} aria-hidden="true" />}>{tr.project.private}</Badge>
    : <Badge tone="info" icon={<IconUsers size={12} stroke={2} aria-hidden="true" />}>{tr.project.shared}</Badge>
}
